import Raven from 'raven-js';
import { isArborHost } from './isArborHost';
export function reportError(error, {
  scope,
  extra
}) {
  if (isArborHost()) return;
  const errorObj = error instanceof Error ? error : new Error(String(error));
  Raven.captureException(errorObj, {
    tags: {
      library_name: 'breeze-engine-lib'
    },
    extra: Object.assign({
      scope
    }, extra)
  });
}